import { createContext, useContext } from "react";

type EntityCreationContextValue = {
  /** Sales CRM flow, which also collects tax classification, incorporation date and business address */
  isFromAdmin: boolean;
};

export const EntityCreationContext = createContext<EntityCreationContextValue>({
  isFromAdmin: false,
});

export const useEntityCreationContext = (): EntityCreationContextValue =>
  useContext(EntityCreationContext);
